<template>
  <div>
    <Table border :columns="columns" :data="orderList"></Table>
    <p class='tips'>注：请尽量提前续费，防止IP回收后无法续费！</p>
    <p class='tips'>购买成功后，预计需要5-10分钟创建时间。之后，请前往客户端【独享定制】使用已购买的节点。</p>
  </div>
</template>
<script>
import axios from "axios";
import doPost from "@/pages/Helper/XHR.js";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      columns: [
        {
          title: "专线类型",
          key: "type",
          align: "center",
          minWidth: 100,
          maxWidth: 100
        },
        {
          title: "套餐过期时间",
          key: "expiration_time",
          align: "center",
          minWidth: 160,
          maxWidth: 160
        },
        {
          title: "IP地址",
          key: "ip",
          align: "center",
          minWidth: 120
        },
        {
          title: "地区",
          key: "address",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h("span", `${params.row.province}-${params.row.city}`)
            ]);
          }
        },
        {
          title: "宽带专线",
          key: "size",
          align: "center",
          minWidth: 100
        },
        {
          title: "运营商",
          key: "provider",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          width: 90,
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "default",
                    style: {
                      marginRight: "5px"
                    }
                  },
                  on: {
                    click: () => this.handleRenew(params.row)
                  }
                },
                "续费"
              )
            ]);
          }
        }
      ],
      orderList: []
    };
  },
  methods: {
    handleRenew(row) {
      // 在这里处理续费操作，row 参数即为当前行的数据
      let { type, size, province, city, provider, serial } = row;
      console.log(type, size, province, city);
      let renewalParameters = {
        type,
        size,
        provider,
        province,
        city,
        line_renew:2,
        serial,
      };
      const oneDay = 24 * 60 * 60 * 1000; // 一天有多少毫秒
      const expiresTimes = new Date(Date.now() + oneDay);
      Cookies.set("renewalParameters", JSON.stringify(renewalParameters), {
        expires: expiresTimes
      });
      Cookies.set("cookieExpiresTimestamp", Date.now() + oneDay, {
        expires: expiresTimes
      });
      // location.href = `/renewal?type=${type}&size=${size}&province=${province}&city=${city}`;
      location.href = "/renewal";
    },
    getExclusiveOrderRecords() {
      doPost(
        {
          action: "user_special_list",
          username: localStorage.getItem("session_str").split("--")[0]
        },
        res => {
          if (res.status == 0) {
            this.orderList = res.detail;
            this.orderList.forEach((item, index) => {
              item.expiration_time = this.formatTimestamp(item.dead_time);
              item.type = item.type==0 ? "动态" : "静态";
            });
          } else {
            if (res.detail == "权限验证失败") {
              this.$Message.warning("登录已过期，即将重新登陆");
              setTimeout(() => {
                this.$emit("loginout");
              }, 1500);
            }
          }
        }
      );
    },
   formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000); // JavaScript时间戳是以毫秒为单位的
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //格式化进度
    formatProgress(time){
      let str = ""
      let buyTime = time*1000
      let nowTime = Date.now()
      let seconds = Math.floor((nowTime-buyTime)/1000)
      if (seconds > 300) {
        str = '生成进度100%';
      } else if (seconds > 240) {
        str = '生成进度80%';
      } else if (seconds > 180) {
        str = '生成进度60%';
      } else if (seconds > 120) {
        str = '生成进度40%';
      } else if (seconds > 60) {
        str = '生成进度20%';
      } else {
        str = '生成进度10%';
      }
      return str;
    }
  },
  created() {
    this.getExclusiveOrderRecords();
  }
};
</script>
<style scoped lang="stylus">
.tips {
  font-size: 14px;
  margin-top: 20px;
  color: red;
}
>>>.ivu-table-wrapper {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}
</style>




// WEBPACK FOOTER //
// src/pages/Personal/components/exclusiveNodeManagement.vue